import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AddEditCompanyModal from './AddEditCompanyModal';
import CallexLoader from '../../../components/CallexLoader';
import Pagination from '../../../components/form/Pagination';
import AdminHeader from '../../../components/header/AdminHeader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  companyDelete,
  companyListGet,
  useCompanyList
} from '../../../store/slices/adminSlices/companySlice';

const Companies = () => {
  const dispatch = useDispatch();
  const companyList = useCompanyList();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: undefined
  });

  const fetchCompanyList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(companyListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteCompany = async () => {
    try {
      const response = await dispatch(companyDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        if (companyList?.data?.length === 1) {
          setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        } else {
          fetchCompanyList();
        }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchCompanyList();
  }, [filter]);

  return (
    <div>
      <AdminHeader
        title="Companies"
        isExpandSearch
        isAdd
        onAddClick={() => setOpenAddModal(true)}
        addBtnName="Add Company"
        searchPlaceholder="Search company"
        search={filter.search}
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          <CallexLoader />
        </Card>
      ) : companyList?.data?.length > 0 ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 210px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Name</th>
                  <th>Company Domain</th>
                  <th>Active</th>
                  <th>Concurrent</th>
                  <th>Company Role</th>
                  <th className="text-center" style={{ width: '90px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {companyList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.username}</td>
                      <td>{val?.name}</td>
                      <td>{val?.company_domain}</td>
                      <td>{val?.active?.toString()}</td>
                      <td>{val?.concurrent}</td>
                      <td>{val?.company_role_name || '-'}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div className="cursor-pointer text-info">
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                setEditRecord(val);
                                setIsEdit(true);
                                setOpenAddModal(true);
                              }}
                            />
                          </div>
                          <div className="cursor-pointer text-danger">
                            <Icon.Trash size={16} onClick={() => setIsDeleteId(val?.id)} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="position-absolute w-100" style={{ bottom: '-56px' }}>
            <Pagination
              totalCount={companyList?.total}
              limit={companyList?.limit}
              page={companyList?.page}
              onLimitChange={(val) => {
                setFilter({ ...filter, page: 1, limit: val });
              }}
              onPageClick={(val) => setFilter({ ...filter, page: val })}
              lastPageClick={(val) => setFilter({ ...filter, page: val })}
              firstPageClick={(val) => setFilter({ ...filter, page: val })}
              onRefreshClick={() => fetchCompanyList()}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteCompany()}
      />
      <AddEditCompanyModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            fetchCompanyList();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
    </div>
  );
};

export default Companies;
